class RelaunchNavigation extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }
  onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.bm-nav-expand');
    if (!button || !this.contains(button)) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel || !this.contains(panel)) return;
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.querySelector('span').textContent = open ? '−' : '+';
    panel.hidden = !open;
    panel.inert = !open;
  };
}
if (!customElements.get('relaunch-navigation')) {
  customElements.define('relaunch-navigation', RelaunchNavigation);
}
